import { authFetch } from 'auth/utils';
import { envVariables } from 'src/common/utils/envVariables';
import { BrandingDTO } from '../types/brandingTypes';

export const fetchBranding = async ({ id }: { id: number }) => {
  const response = await authFetch(
    `${envVariables.VITE_SIM_INVENTORY_ACCOUNTS_API}/${id}/branding`,
  );

  const brandingData: BrandingDTO = await response.json();
  return brandingData;
};
